<template>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PictureInput from 'vue-picture-input';
  import ContentEditor from '~/components/ContentEditor';

  export default {
    name: 'AdminPage',
    components: {
      ContentEditor,
      PictureInput,
    },
    data: () => ({
    }),
    computed: mapGetters({
    }),
    methods: {
    },
    mounted () {
    },
    beforeMount () {
    }
  }
</script>
